module.exports = __webpack_public_path__ + "static/media/newDiscord.81c174a5.svg";